import React, { useEffect, useContext } from 'react';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';
import { Input } from '@m/alchemy-ui';
import { TriggerContext } from '../../../../../../..';
import TargetingBlockRow from '../../../TargetingBlockRow';
import { TargetingActions } from '../../../../../Actions';
import { isRuleExists, formatInputTextValue } from '../../../../../../../helpers';
import { getSingleText } from '../../../../../../../../../../common/utils';
import { TextPathPrefix } from '../../../../../index';
import useVersionValidation from '../hooks/useVersionValidation';

const TargetByOSVersion = () => {
  const { triggerState, triggerDispatch, isReadOnly } = useContext(TriggerContext);
  const [hasError, setHasError] = useVersionValidation('trigger.rules.MobileOsVersion');

  useEffect(() => {
    isRuleExists(triggerState, 'trigger.rules.MobileOsVersion.id') ?
      triggerDispatch({ type: TargetingActions.SET_TARGET_BY_OS_VERSION_IS_ACTIVE, payload: true }) :
      triggerDispatch({ type: TargetingActions.INIT_TARGET_BY_OS_VERSION_PARAMS, payload: {} });
  }, []);

  const handleOsVersionChange = (e) => {
    triggerDispatch({ type: TargetingActions.SET_TARGET_BY_OS_VERSION, payload: e.target.value.split(',') });
    setHasError(e.target.value === '');
  };

  return (
    <TargetingBlockRow
      checkboxLabel="OS version"
      isFullWidth
      checked={getNestedProperty(triggerState, 'trigger.rules.MobileOsVersion.isActive')}
      disabled={isReadOnly}
      hasError={hasError}
      errorMessage={getSingleText(`${TextPathPrefix}.errors.required`)}
      onCheckboxChange={(e) => triggerDispatch({ type: TargetingActions.SET_TARGET_BY_OS_VERSION_IS_ACTIVE, payload: e.target.checked })}>
      <Input
        className='targeting-large-field'
        value={formatInputTextValue(triggerState, 'trigger.rules.MobileOsVersion.params.versions')}
        onChange={handleOsVersionChange} />
    </TargetingBlockRow>
  );
};

export default TargetByOSVersion;
